<template>
  <DownloadScheme />
  <DownloadSchemeButton />
  <div class="spinner-page" v-if="areGrantDetailsLoading">
    <q-spinner class="spinner" color="primary" size="3em" />
  </div>
  <div
    v-else
    class="row justify-around grant-details-page"
    :class="{ 'high-contrast': isContrast }"
  >
    <nav class="col-md-2 navigation">
      <ul>
        <li>
          <a href="#introduction" v-if="scheme.introduction">{{
            t(
              "share_and_download_schemes.description",
              {},
              { locale: determineLocale().value },
            )
          }}</a>
          <a href="#body" v-if="scheme.body">{{
            t("scheme_details.body", {}, { locale: determineLocale().value })
          }}</a>
          <a href="#criteria" v-if="scheme.criteria && isVind">{{
            t(
              "scheme_details.criteria",
              {},
              { locale: determineLocale().value },
            )
          }}</a>
          <a href="#bijdrage" v-if="isVind && scheme.financialInformation">{{
            t(
              "scheme_details.contribution",
              {},
              { locale: determineLocale().value },
            )
          }}</a>
          <a
            href="#customers-schemes"
            v-if="schemeCustomers.length > 0 && isUserFomo != false"
            >{{
              t(
                "scheme_details.customers",
                {},
                { locale: determineLocale().value },
              )
            }}
          </a>
          <a
            href="#docsandlinks"
            v-if="
              isVind &&
              ((scheme.schemeLinks && scheme.schemeLinks.length > 0) ||
                (scheme.schemeDocuments && scheme.schemeDocuments.length > 0))
            "
          >
            {{
              t(
                "scheme_details.documents_and_links",
                {},
                { locale: determineLocale().value },
              )
            }}
          </a>
          <a href="#news" v-if="scheme.news && scheme.news.length > 0">{{
            t("search_news.news", {}, { locale: determineLocale().value })
          }}</a>
          <a
            href="#organisations"
            v-if="organisationsList && organisationsList.length > 0"
            >{{
              t(
                "scheme_details.organizations",
                {},
                { locale: determineLocale().value },
              )
            }}</a
          >
          <a
            href="#calls"
            v-if="
              isVind &&
              scheme.children &&
              scheme.children.length > 0 &&
              !scheme.isCall &&
              !scheme.isApplicationPeriod
            "
          >
            {{
              t(
                "scheme_details.related_opening",
                {},
                { locale: determineLocale().value },
              )
            }}
          </a>
        </li>
      </ul>
    </nav>

    <div class="col-md-9 page-details">
      <div class="column pagetop">
        <q-icon
          name="fa-solid fa-arrow-left"
          size="18px"
          class="back-icon"
          @click="router.go(-1)"
        ></q-icon>

        <div class="column">
          <div class="row heading-scheme">
            <div class="column scheme-name-and-org bold-font">
              <div>
                <span
                  class="title"
                  v-html="translateScheme ? transName : scheme.name"
                ></span>
              </div>
            </div>
          </div>
          <div class="row justify-between items-center btns-row">
            <div class="row icons-row" v-if="isVind">
              <q-icon
                name="fa-solid fa-floppy-disk"
                size="20px"
                class="action-icon"
                @click="enableSaveScheme(scheme.id)"
              >
                <q-tooltip> {{ t("search_schemes.save") }} </q-tooltip></q-icon
              >
              <q-icon
                v-if="!isSKS"
                name="fa-solid fa-share-nodes"
                size="20px"
                class="action-icon q-ml-md"
                @click="shareGrant()"
              >
                <q-tooltip> {{ t("search_schemes.share") }} </q-tooltip></q-icon
              >
              <q-icon
                name="fa-solid fa-download"
                size="20px"
                class="action-icon q-ml-md"
                @click="downloadSchemePopup(scheme.id)"
              >
                <q-tooltip>
                  {{ t("search_schemes.download") }}
                </q-tooltip></q-icon
              >

              <div v-if="scheme.isEnglishScheme" class="q-ml-md">
                <country-flag
                  v-if="!translateScheme"
                  country="gb"
                  class="country-flag-icon"
                />
                <country-flag
                  v-else
                  :country="locale"
                  class="country-flag-icon"
                />
              </div>
              <q-toggle
                v-show="scheme.isEnglishScheme"
                v-model="translateScheme"
                @click="
                  translateScheme == true
                    ? getTranslation(scheme.id)
                    : getSchemeById(scheme.id)
                "
              >
                <q-tooltip>
                  <p v-if="!translateScheme && locale === 'nl'">
                    Vertaal deze regeling in het Nederlands
                  </p>
                  <p v-else-if="!translateScheme && locale === 'de'">
                    {{ t("scheme_details.translate_to_german") }}
                  </p>
                  <p v-else>{{ t("scheme_details.translate_to_english") }}</p>
                </q-tooltip>
              </q-toggle>
            </div>

            <div class="bold-font">
              <q-btn
                color="white"
                class="orange-btn-filled"
                flat
                :label="t('scheme_details.keep_me_informed')"
                no-caps
                @click="enableSaveScheme(scheme.id)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="column main-page q-mt-md">
        <div class="top-details-bg">
          <dl class="grant-details-definition-list">
            <div class="top-info-item">
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img
                    class="svg-icon"
                    src="../assets/icons/calendar-days-solid.svg"
                  />
                </q-icon>
                <span class="heading">
                  {{
                    scheme.currentDeadlineHeaderText ??
                    t(
                      "scheme_details.deadline",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd class="top-info-item-value">
                {{ scheme.currentDeadlineText ?? "-" }}
              </dd>
            </div>
            <div
              class="top-info-item"
              v-if="!scheme.isCall && !scheme.isApplicationPeriod"
            >
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img
                    class="svg-icon"
                    src="../assets/icons/calendar-lines-pen-solid.svg"
                  />
                </q-icon>
                <span class="heading">
                  {{
                    t(
                      "scheme_details.application_period",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd class="top-info-item-value">
                {{
                  scheme.applicationTerm !== "Onbepaald"
                    ? scheme.applicationTerm
                    : scheme.applicationTermText &&
                      scheme.applicationTermText !== ""
                    ? scheme.applicationTermText
                    : scheme.applicationTerm
                }}
              </dd>
            </div>
            <div
              class="top-info-item"
              v-if="!scheme.isCall && !scheme.isApplicationPeriod"
            >
              <dt class="top-info-item-heading bold-font">
                <q-icon
                  name="fa-solid fa-location-dot"
                  size="20px"
                  class="heading-icon"
                />
                <span class="heading">
                  {{
                    t(
                      "scheme_details.range",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd class="top-info-item-value">
                {{ scheme.scopeDescription }}
              </dd>
            </div>
            <div class="top-info-item">
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img
                    class="svg-icon"
                    src="../assets/icons/spinner-solid.svg"
                  />
                </q-icon>
                <span class="heading">
                  {{
                    t(
                      "search_schemes.status",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd class="top-info-item-value">{{ scheme.status ?? "-" }}</dd>
            </div>
            <div
              class="top-info-item"
              v-if="!scheme.isCall && !scheme.isApplicationPeriod"
            >
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img class="svg-icon" src="../assets/icons/memo-solid.svg" />
                </q-icon>
                <span class="heading">
                  {{
                    t(
                      "search_schemes.submission_procedure",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd v-if="!translateScheme" class="top-info-item-value procedure">
                {{ scheme.applicationProcedure ?? "-" }}
              </dd>
              <dd v-else class="top-info-item-value procedure">
                {{ transApplicationProcedure ?? "-" }}
              </dd>
            </div>
            <div v-if="!scheme.isCall" class="top-info-item">
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img class="svg-icon" src="../assets/icons/coin-solid.svg" />
                </q-icon>
                <span class="heading">
                  {{
                    t(
                      "scheme_details.min_amount",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd class="top-info-item-value">
                <span
                  v-if="!scheme.minAmount || scheme.minAmount < 1"
                  class="detail-value"
                >
                  {{
                    t(
                      "search_schemes.indefinite",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
                <span v-if="scheme.minAmount && scheme.minAmount > 1">{{
                  formattedMinAmount ?? "-"
                }}</span>
              </dd>
            </div>
            <div v-if="!scheme.isCall" class="top-info-item">
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img class="svg-icon" src="../assets/icons/coin-solid.svg" />
                </q-icon>
                <span class="heading">
                  {{
                    t(
                      "search_schemes.max_budget",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd class="top-info-item-value">
                <span
                  v-if="!scheme.maxAmount || scheme.maxAmount < 1"
                  class="detail-value"
                  >{{
                    t(
                      "search_schemes.indefinite",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
                <span v-if="scheme.maxAmount && scheme.maxAmount > 1">{{
                  formattedMaxAmount ?? "-"
                }}</span>
              </dd>
            </div>
            <div class="top-info-item" v-if="isVind">
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img class="svg-icon" src="../assets/icons/clock-solid.svg" />
                </q-icon>
                <span class="heading"
                  >{{
                    t(
                      "scheme_details.duration",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd v-if="!translateScheme" class="top-info-item-value budget">
                {{ scheme.duration ?? "-" }}
              </dd>
              <dd v-else class="top-info-item-value procedure">
                {{ transDuration ?? "-" }}
              </dd>
            </div>
            <div class="top-info-item">
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img class="svg-icon" src="../assets/icons/sack-solid.svg" />
                </q-icon>
                <span class="heading"
                  >{{
                    t(
                      "scheme_details.budget",
                      {},
                      { locale: determineLocale().value },
                    )
                  }}
                </span>
              </dt>
              <dd
                v-if="
                  !translateScheme &&
                  scheme.budget &&
                  !showMoreBudget &&
                  scheme.budget.length > 130
                "
                class="top-info-item-value budget"
                style="max-width: 320px"
              >
                <div
                  class="top-info-item-value-budget budget"
                  v-html="scheme.shortBudget"
                ></div>
                <span
                  v-if="!showMoreBudget"
                  @click="toggleShowMoreBudget()"
                  class="show-more"
                  >{{ t("search_news.read_more") }}
                  <q-icon size="14px" class="heading-icon">
                    <img
                      class="svg-icon"
                      src="../assets/icons/chevron-right-solid.svg"
                    /> </q-icon
                ></span>
              </dd>
              <dd
                v-else-if="
                  translateScheme &&
                  transBudget &&
                  !showMoreBudget &&
                  transBudget.length > 130
                "
                class="top-info-item-value procedure"
                style="max-width: 320px"
              >
                <div
                  class="top-info-item-value-budget procedure"
                  v-html="scheme.shortBudgetTrans"
                ></div>
                <span
                  v-if="!showMoreBudget"
                  @click="toggleShowMoreBudget()"
                  class="show-more"
                >
                  {{ t("search_news.read_more") }}
                  <q-icon size="14px" class="heading-icon">
                    <img
                      class="svg-icon"
                      src="../assets/icons/chevron-right-solid.svg"
                    />
                  </q-icon>
                </span>
              </dd>
              <dd
                v-else-if="scheme.budget && showMoreBudget"
                class="top-info-item-value budget"
                style="max-width: 320px"
              >
                <div
                  class="top-info-item-value-budget budget"
                  v-html="translateScheme ? transBudget : scheme.budget"
                ></div>
                <span
                  v-if="showMoreBudget"
                  @click="toggleShowMoreBudget()"
                  class="show-more"
                  >{{ t("search_news.read_less") }}
                  <q-icon size="14px" class="heading-icon">
                    <img
                      class="svg-icon"
                      src="../assets/icons/chevron-left-solid.svg"
                    /> </q-icon
                ></span>
              </dd>
              <dd
                v-else-if="
                  scheme.budget && !showMoreBudget && scheme.budget.length < 130
                "
                class="top-info-item-value budget"
              >
                <div
                  class="top-info-item-value-budget budget"
                  v-html="translateScheme ? transBudget : scheme.budget"
                ></div>
              </dd>
              <dd class="top-info-item-value budget" v-else>-</dd>
            </div>
            <div
              class="top-info-item"
              v-if="
                scheme.complexityRating != null && scheme.complexityRating > 0
              "
            >
              <dt class="top-info-item-heading bold-font">
                <q-icon name="speed" size="20px" class="heading-icon" />{{
                  t(
                    "scheme_details.difficulty",
                    {},
                    { locale: determineLocale().value },
                  )
                }}
              </dt>
              <dd style="text-align: left" class="top-info-item-value">
                <q-linear-progress
                  size="15px"
                  :value="(scheme.complexityRating / 10) * 2"
                  class="progress-bar"
                  :color="getRatingColor(scheme.complexityRating)"
                  :aria-label="
                    getComplexityRatingLabel(scheme.complexityRating)
                  "
                />

                <q-tooltip
                  anchor="bottom middle"
                  self="bottom middle"
                  class="rating-tooltip"
                  style="
                    color: black;
                    background-color: white;
                    font-size: small;
                  "
                >
                  {{ getComplexityRatingLabel(scheme.complexityRating) }}
                </q-tooltip>
              </dd>
            </div>
            <div
              class="top-info-item"
              v-if="
                scheme.timeForApplicationRating != null &&
                scheme.timeForApplicationRating > 0
              "
            >
              <dt class="top-info-item-heading bold-font">
                <q-icon name="timer" size="20px" class="heading-icon" />{{
                  t(
                    "scheme_details.time_for_application",
                    {},
                    { locale: determineLocale().value },
                  )
                }}
              </dt>
              <dd style="text-align: left" class="top-info-item-value">
                <q-linear-progress
                  size="15px"
                  :value="(scheme.timeForApplicationRating / 10) * 2"
                  class="progress-bar"
                  :color="
                    getTimeForApplicationRatingLabel(
                      scheme.timeForApplicationRating,
                    )
                  "
                  :aria-label="
                    getComplexityRatingLabel(scheme.timeForApplicationRating)
                  "
                />
                <q-tooltip
                  anchor="bottom middle"
                  self="bottom middle"
                  class="rating-tooltip"
                  style="
                    color: black;
                    background-color: white;
                    font-size: small;
                  "
                >
                  {{
                    getTimeForApplicationRatingLabel(
                      scheme.timeForApplicationRating,
                    )
                  }}
                </q-tooltip>
              </dd>
            </div>
            <div
              class="top-info-item"
              v-if="
                scheme.chanceOfSuccessRating != null &&
                scheme.chanceOfSuccessRating > 0
              "
            >
              <dt class="top-info-item-heading bold-font">
                <q-icon size="20px" class="heading-icon">
                  <img
                    class="svg-icon"
                    src="../assets/icons/circle-check-solid.svg"
                  />
                </q-icon>

                {{
                  t(
                    "scheme_details.chance_of_success",
                    {},
                    { locale: determineLocale().value },
                  )
                }}
              </dt>
              <dd style="text-align: left" class="top-info-item-value">
                <q-linear-progress
                  size="15px"
                  :value="(scheme.chanceOfSuccessRating / 10) * 2"
                  class="progress-bar"
                  :color="
                    getChanceOfSuccessRatingColor(scheme.chanceOfSuccessRating)
                  "
                  :aria-label="
                    getChanceOfSuccessRatingLabel(scheme.chanceOfSuccessRating)
                  "
                />
                <q-tooltip
                  anchor="bottom middle"
                  self="bottom middle"
                  class="rating-tooltip"
                  style="
                    color: black;
                    background-color: white;
                    font-size: small;
                  "
                >
                  {{
                    getChanceOfSuccessRatingLabel(scheme.chanceOfSuccessRating)
                  }}
                </q-tooltip>
              </dd>
            </div>
          </dl>
        </div>
        <div class="row page-lower">
          <section id="introduction" v-if="scheme.introduction">
            <div class="large-item first-lg">
              <span class="box-title bold-font">
                {{
                  t(
                    "share_and_download_schemes.description",
                    {},
                    { locale: determineLocale().value },
                  )
                }}</span
              >

              <div class="introduction">
                <div
                  v-html="
                    translateScheme ? transIntroduction : scheme.introduction
                  "
                ></div>
              </div>
            </div>
            <q-separator
              class="full-width-separator"
              v-if="scheme.introduction"
            />
          </section>

          <section id="body" v-if="scheme.body">
            <div class="large-item">
              <span class="box-title bold-font">
                {{
                  t(
                    "scheme_details.body",
                    {},
                    { locale: determineLocale().value },
                  )
                }}
              </span>
              <div
                v-html="translateScheme ? transBody : scheme.body"
                class="introduction"
              ></div>
              <div id="criteria"></div>
              <div
                class="introduction"
                v-if="scheme.applicationInformation"
                v-html="
                  translateScheme
                    ? transApplicationInformation
                    : scheme.applicationInformation
                "
              ></div>
            </div>
            <q-separator class="full-width-separator" v-if="scheme.body" />
          </section>

          <section id="criteria" v-if="scheme.criteria && isVind">
            <div class="large-item">
              <span class="box-title bold-font">
                {{
                  t(
                    "scheme_details.criteria",
                    {},
                    { locale: determineLocale().value },
                  )
                }}
              </span>
              <div
                v-html="translateScheme ? transCriteria : scheme.criteria"
                class="introduction"
              ></div>
            </div>
          </section>
          <q-separator class="full-width-separator" v-if="scheme.criteria" />

          <section id="bijdrage" v-if="scheme.financialInformation && isVind">
            <div class="large-item">
              <span class="box-title bold-font">
                {{
                  t(
                    "scheme_details.contribution",
                    {},
                    { locale: determineLocale().value },
                  )
                }}
              </span>
              <div
                v-if="scheme.financialInformation"
                v-html="
                  translateScheme
                    ? transFinancialinformation
                    : scheme.financialInformation
                "
                class="introduction"
              ></div>
            </div>
          </section>

          <q-separator
            class="full-width-separator"
            v-if="
              isVind &&
              ((scheme.schemeLinks && scheme.schemeLinks.length > 0) ||
                (scheme.schemeDocuments && scheme.schemeDocuments.length > 0))
            "
          />

          <section
            id="docsandlinks"
            v-if="
              isVind &&
              ((scheme.schemeLinks && scheme.schemeLinks.length > 0) ||
                (scheme.schemeDocuments && scheme.schemeDocuments.length > 0))
            "
          >
            <div class="large-item">
              <span class="box-title bold-font">
                {{
                  t(
                    "scheme_details.external_information",
                    {},
                    { locale: determineLocale().value },
                  )
                }}
              </span>
              <div
                class="scheme-links-sorted"
                v-if="sortedLinksAndDocs && sortedLinksAndDocs.length > 0"
              >
                <div
                  v-for="link in sortedLinksAndDocs"
                  :key="link.id"
                  class="links-list-sorted"
                >
                  <div
                    v-if="
                      link.url &&
                      link.url.length > 0 &&
                      link.documentType === EDocumentType.UsefulLinks
                    "
                    class="sorted-link row"
                  >
                    <i
                      class="fa-solid fa-link q-mt-xs"
                      style="color: #191d96"
                    ></i>

                    <span
                      class="doc-type"
                      v-if="link.documentType === EDocumentType.UsefulLinks"
                    >
                      {{
                        t(
                          "scheme_details.useful_links",
                          {},
                          { locale: determineLocale().value },
                        )
                      }}
                    </span>
                    <span class="doc-type" v-else>
                      {{ link.documentTypeDescription }}
                    </span>
                    <a class="link-item" :href="link.url" target="_blank">
                      {{ link.text }}
                    </a>
                  </div>
                </div>
              </div>
              <span class="box-title bold-font q-mt-lg">
                {{
                  t(
                    "scheme_details.other_links_and_files",
                    {},
                    { locale: determineLocale().value },
                  )
                }}
              </span>
              <div
                class="scheme-links-sorted"
                v-if="sortedLinksAndDocs && sortedLinksAndDocs.length > 0"
              >
                <div
                  v-for="link in sortedLinksAndDocs"
                  :key="link.id"
                  class="links-list-sorted"
                >
                  <div
                    v-if="
                      link.url &&
                      link.url.length > 0 &&
                      link.documentType != EDocumentType.UsefulLinks &&
                      link.documentType != EDocumentType.VisualPingLink &&
                      !isDeprecatedDocumentType(link.documentType)
                    "
                    class="sorted-link row"
                  >
                    <i
                      class="fa-solid fa-link q-mt-xs"
                      style="color: #191d96"
                    ></i>
                    <span class="doc-type">
                      {{ link.documentTypeDescription }}
                    </span>

                    <a class="link-item" :href="link.url" target="_blank">
                      {{ link.text }}
                    </a>
                  </div>
                  <div
                    v-if="
                      !link.url &&
                      link.documentType != EDocumentType.UsefulLinks &&
                      link.documentType != EDocumentType.VisualPingLink &&
                      !isDeprecatedDocumentType(link.documentType)
                    "
                    class="sorted-doc row"
                  >
                    <div class="icon-container-scheme-details">
                      <i
                        :class="iconBasedOnExtension(link.extension)"
                        class="link-icon"
                        style="color: #191d96"
                      ></i>
                    </div>
                    <span class="doc-type">
                      {{ link.documentTypeDescription }}
                    </span>

                    <div
                      class="link-item docname"
                      @click="download(link.id, link.name)"
                    >
                      {{ link.name }}
                    </div>
                  </div>
                </div>
              </div>

              <q-btn
                @click="updateSeeDeprecatedItems(true)"
                v-if="!seeDeprecatedItems"
                class="deprecated-btn row q-mt-sm"
                flat
                no-caps
                :label="t('scheme_details.see_deprecated')"
                ><i class="las la-angle-down q-ml-xs"></i
              ></q-btn>

              <q-btn
                @click="updateSeeDeprecatedItems(false)"
                v-else
                class="deprecated-btn row q-mt-sm"
                flat
                no-caps
                :label="t('scheme_details.hide_deprecated')"
              >
                <i class="las la-angle-up q-ml-xs"></i
              ></q-btn>
              <div
                class="scheme-links-sorted"
                v-if="
                  sortedLinksAndDocs &&
                  sortedLinksAndDocs.length > 0 &&
                  seeDeprecatedItems
                "
              >
                <div
                  v-for="link in sortedLinksAndDocs"
                  :key="link.id"
                  class="links-list-sorted"
                >
                  <div
                    v-if="
                      link.url &&
                      link.url.length > 0 &&
                      link.documentType != EDocumentType.UsefulLinks &&
                      link.documentType != EDocumentType.VisualPingLink &&
                      isDeprecatedDocumentType(link.documentType)
                    "
                    class="sorted-link row"
                  >
                    <i
                      class="fa-solid fa-link q-mt-xs"
                      style="color: #191d96"
                    ></i>
                    <span class="doc-type">
                      {{ link.documentTypeDescription }}
                    </span>

                    <a
                      class="link-item q-ml-md"
                      :href="link.url"
                      target="_blank"
                    >
                      {{ link.text }}
                    </a>
                  </div>
                  <div
                    v-if="
                      !link.url &&
                      link.documentType != EDocumentType.UsefulLinks &&
                      link.documentType != EDocumentType.VisualPingLink &&
                      isDeprecatedDocumentType(link.documentType)
                    "
                    class="sorted-doc row"
                  >
                    <div class="icon-container-scheme-details">
                      <i
                        :class="iconBasedOnExtension(link.extension)"
                        class="link-icon"
                      ></i>
                    </div>
                    <span class="doc-type">
                      {{ link.documentTypeDescription }}
                    </span>

                    <div
                      class="link-item docname"
                      @click="download(link.id, link.name)"
                    >
                      {{ link.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <q-separator
            v-if="!isVind && organisationsList && organisationsList.length > 0"
            class="full-width-separator"
          />

          <section
            id="organisations"
            v-if="!isVind && organisationsList && organisationsList.length > 0"
          >
            <div class="large-item">
              <span class="box-title bold-font">{{
                t("scheme_details.more_information")
              }}</span>

              <div class="scheme-news">
                <span class="links-title">{{
                  t("scheme_details.organization")
                }}</span>

                <div
                  v-for="organisation in organisationsList"
                  :key="organisation.id"
                  class="news-list"
                >
                  <div class="column">
                    <span class="organisation-name">
                      {{ organisation.name + " (" + organisation.type + ")" }}
                    </span>
                    <div class="row">
                      <span
                        v-if="
                          organisation.addresses &&
                          organisation.addresses.length > 0
                        "
                        class="organisation-address q-ml-md"
                        >{{ organisation.addresses[0].addressLine1
                        }}{{
                          organisation.addresses[0].addressLine2 != null
                            ? `, ${organisation.addresses[0].addressLine2}`
                            : ""
                        }}{{
                          organisation.addresses[0].addressLine3 != null
                            ? `, ${organisation.addresses[0].addressLine3}`
                            : ""
                        }}
                      </span>
                      <span v-if="organisation.phone" class="q-ml-sm org-info">
                        {{ organisation.phone }}
                      </span>
                      <a
                        v-if="organisation.url"
                        class="q-ml-sm org-info"
                        :href="organisation.url"
                      >
                        {{ organisation.url }}
                      </a>
                      <span v-if="organisation.email" class="q-ml-sm org-info">
                        {{ organisation.email }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <q-separator class="full-width-separator" />

          <q-separator
            class="full-width-separator"
            v-if="scheme.news && scheme.news.length > 0"
          />

          <section id="news" v-if="scheme.news && scheme.news.length > 0">
            <div class="large-item">
              <span class="box-title bold-font"
                >{{
                  t("search_news.news", {}, { locale: determineLocale().value })
                }}
              </span>

              <div class="scheme-news">
                <span class="links-title">{{
                  t("scheme_details.news_last_year")
                }}</span>

                <div
                  v-for="news in newsInLastYear"
                  :key="news.id"
                  class="news-list"
                >
                  <router-link
                    class="news-link"
                    style="text-decoration: underline"
                    :to="{
                      name: 'NewsDetails',
                      params: { newsId: news.id },
                    }"
                    target="_blank"
                    :aria-label="t('news_details.details')"
                  >
                    {{ news.title }}
                  </router-link>
                  <span
                    v-if="news.date && news.date.length >= 10"
                    class="news-date q-ml-md"
                  >
                    {{ formatDate(news.date) }}
                  </span>
                </div>

                <div class="older-news-list" v-if="showMore">
                  <span class="older-news-heading">{{
                    t("scheme_details.older_news")
                  }}</span>
                  <div
                    v-for="news in olderNews"
                    :key="news.id"
                    class="news-list"
                  >
                    <router-link
                      class="news-link"
                      style="text-decoration: underline"
                      :to="{
                        name: 'NewsDetails',
                        params: { newsId: news.id },
                      }"
                      target="_blank"
                      :aria-label="t('news_details.details')"
                    >
                      {{ news.title }}
                    </router-link>
                    <span
                      v-if="news.date && news.date.length >= 10"
                      class="news-date q-ml-md"
                    >
                      {{ formatDate(news.date.substring(0, 10)) }}
                    </span>
                  </div>
                </div>
              </div>

              <span
                v-if="!showMore && olderNews && olderNews.length > 0"
                @click="toggleShowMore()"
                class="news-btn"
                >{{ t("scheme_details.more_news") }}</span
              >
              <span
                v-if="showMore"
                @click="toggleShowMore()"
                class="news-btn"
                >{{ t("scheme_details.hide_older_news") }}</span
              >
            </div>
            <q-separator
              v-if="isVind && organisationsList && organisationsList.length > 0"
              class="full-width-separator"
            />
          </section>

          <section
            id="organisations"
            class="large-item"
            v-if="isVind && organisationsList && organisationsList.length > 0"
          >
            <span class="box-title bold-font">{{
              t(
                "scheme_details.organizations",
                {},
                { locale: determineLocale().value },
              )
            }}</span>

            <div
              v-for="organisation in organisationsList"
              :key="organisation.id"
              class="q-mt-sm"
            >
              <p class="organisation-name">
                {{ organisation.name + " (" + organisation.type + ")" }}
                <router-link
                  :to="{ name: 'SearchGrants' }"
                  target="_blank"
                  :aria-label="
                    t('scheme_details.view_all_schemes_of_this_organization')
                  "
                >
                  <i
                    class="las la-2x la-link icon-hover"
                    @click="getClickedOrganisation(organisation.id)"
                  >
                    <q-tooltip>
                      {{
                        t(
                          "scheme_details.view_all_schemes_of_this_organization",
                        )
                      }}
                    </q-tooltip>
                  </i>
                </router-link>
              </p>

              <span
                v-if="
                  organisation.addresses && organisation.addresses.length > 0
                "
                class="organisation-address q-ml-md"
                >{{ organisation.addresses[0].addressLine1
                }}{{
                  organisation.addresses[0].addressLine2 != null
                    ? `, ${organisation.addresses[0].addressLine2}`
                    : ""
                }}{{
                  organisation.addresses[0].addressLine3 != null
                    ? `, ${organisation.addresses[0].addressLine3}`
                    : ""
                }}
              </span>

              <div class="address-info">
                <span v-if="organisation.phone" class="org-info blue-text">
                  {{ organisation.phone }}
                </span>
                <a
                  v-if="organisation.url"
                  class="org-info"
                  :href="organisation.url"
                  target="_blank"
                  style="text-decoration: underline"
                >
                  {{ organisation.url }}
                </a>
                <span
                  v-if="organisation.email"
                  style="text-decoration: underline"
                  class="org-info"
                >
                  {{ organisation.email }}
                </span>
              </div>
            </div>
          </section>

          <q-separator
            class="full-width-separator"
            style="margin-bottom: 16px"
          />

          <section
            id="customers-schemes"
            class="large-item"
            v-if="schemeCustomers.length > 0 && isUserFomo != false"
          >
            <span class="box-title bold-font q-mb-md">{{
              t(
                "scheme_details.customers",
                {},
                { locale: determineLocale().value },
              )
            }}</span>
            <div class="scheme-customers-card-table">
              <div class="customers-table-wrapper">
                <q-table
                  class="my-sticky-header-table"
                  flat
                  dense
                  :rows="schemeCustomers"
                  :columns="schemeCustomersColumns"
                  style="min-width: fit-content"
                />
              </div>
            </div>
            <q-separator class="q-mt-md full-width-separator" />
          </section>

          <section
            v-if="
              isVind &&
              scheme.children &&
              scheme.children.length > 0 &&
              !scheme.isCall &&
              !scheme.isApplicationPeriod
            "
            class="large-item"
            id="calls"
          >
            <span class="box-title bold-font q-pb-md">{{
              t(
                "scheme_details.related_opening",
                {},
                { locale: determineLocale().value },
              )
            }}</span>
            <Calls @items-loaded="handleLoadedCallsAndApplicationPeriodsIds" :schemeId="scheme.id" :countOfActiveOpenings="scheme.countOfActiveOpenings" :countOfPastOpenings="scheme.countOfPastOpenings" :countOfFutureOpenings="scheme.countOfFutureOpenings"/>
          </section>
        </div>
      </div>
    </div>

    <div class="circle-container">
      <div id="pagetop" class="top-scroll" v-if="scY > 300">
        <i class="las la-2x la-angle-up up-icon" @click="toTop">
          <q-tooltip self="center left" :offset="[10, 10]">{{
            t("search_schemes.upwards")
          }}</q-tooltip>
        </i>
      </div>
    </div>
  </div>
  <q-dialog v-model="showSavedInfoDialog">
    <q-card>
      <q-card-section class="row items-center">
        <q-icon
          class="info-icon-searchgrants"
          size="28px"
          name="fa-solid fa-circle-info"
          @click="hideScheme(schemeId)"
        >
        </q-icon>
        <span class="q-ml-sm">
          {{ t("search_schemes.saved_item_notification") }} &nbsp;
        </span>
        <router-link
          :to="{ name: 'UserProfile', params: { tab: 'savedItemsSchemes' } }"
        >
          {{ t("search_schemes.saved_items") }}
        </router-link>
      </q-card-section>
      <q-card-section style="padding-top: 0; padding-left: 12px" v-if="isVind">
        <q-toggle
          v-model="receiveAlertForSavedItems"
          :label="t('search_schemes.receive_alerts_for_saved_items_question')"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          flat
          class="orange-btn-filled"
          color="white"
          :label="t('common.ok')"
          no-caps
          @click="disableShowSavedInfoDialog()"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <div v-if="hasUser && !isSKS">
    <ShareGrant />
    <SaveScheme />
  </div>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { onMounted, computed, ref, provide, onBeforeMount } from "vue";
import moment from "moment";
import GrantsSevice from "../services/grants.service";
import store from "../store/index";
import grantsService from "../services/grants.service";
import ShareGrant from "../components/share-components/ShareScheme.vue";
import SaveScheme from "../components/SaveScheme.vue";
import mailingService from "../services/mailing.service";
import Calls from "../components/Calls.vue";
import OrganisationsUtils from "../utils/organisations";
import DownloadSchemeButton from "../components/share-components/DownloadSchemeButton.vue";
import DownloadScheme from "../components/share-components/DownloadScheme.vue";
import UserService from "../services/userprofile.service";
import { date } from "quasar";
import { useI18n } from "vue-i18n";
import {
  EDocumentType,
  isDeprecatedDocumentType,
} from "../enums/EDocumentType";

export default {
  components: {
    ShareGrant,
    SaveScheme,
    Calls,
    DownloadScheme,
    DownloadSchemeButton,
  },
  setup() {
    const { t, locale } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const displayedCallsAndApplicationPeriodsIds = ref([]);
    onBeforeMount(() => {
      if (!isVind.value) {
        router.push({
          name: "PortalSchemeDetails",
          params: {
            grantId: route.params.grantId,
          },
        });
      }
    });
    const englishLocale = ref("en");
    const getSchemeById = async (id) => {
      await GrantsSevice.getSchemeById(id, locale);
    };
    const authUser = computed({
      get: () => store.state.auth.authUser,
    });

    onMounted(async () => {
      await UserService.getProfileConfiguration();
      await mailingService.getReportTypes(
        isVind.value,
        authUser.value.customerId,
      );
      const id = route.params.grantId;
      await getSchemeById(id);
      OrganisationsUtils.generateOrganisationsForDetailsPage(t);
      window.addEventListener("scroll", handleScroll);
      localStorage.setItem("schemeOrganisationClicked", false);
      await GrantsSevice.getSchemeCustomers(route.params.grantId);
      store.commit("grantItems/updateTranslateScheme", false);
    });

    const handleLoadedCallsAndApplicationPeriodsIds = (ids) => {
      displayedCallsAndApplicationPeriodsIds.value = ids;
    }
    
    const translateScheme = computed({
      get: () => store.state.grantItems.translateScheme,
      set: (val) => store.commit("grantItems/updateTranslateScheme", val),
    });
    const scheme = computed({
      get: () => store.state.grantItems.selectedGrant,
    });

    const shortIntro = computed({
      get: () => store.state.grantItems.shortIntro,
    });

    const schemeCustomers = computed({
      get: () => store.state.grantItems.schemeCustomers,
    });

    const isUserFomo = computed({
      get: () => store.state.auth.authUser,
    });
    const showMore = ref(false);

    const columns = [
      {
        name: "year",
        label: "Year",
        field: "year",
        sortable: true,
        align: "left",
      },
      {
        name: "amount",
        label: "Amount (€)",
        field: "amount",
        sortable: true,
        align: "left",
      },
    ];

    const schemeCustomersColumns = [
      {
        name: "customer",
        label: "Ontvanger",
        field: "customer",
        align: "left",
      },
      {
        name: "applicationSubject",
        label: "Onderwerp van de aanvraag",
        field: "applicationSubject",
        align: "left",
      },
      {
        name: "year",
        label: "Jaar",
        field: "dateTimeGranted",
        align: "left",
        format: (val) => date.formatDate(val, "YYYY"),
      },
      {
        name: "amount",
        label: "Bedrag",
        field: "amount",
        align: "left",
        format: (val) => {
          var amount = Math.floor(val);
          return amount >= 1000000
            ? `€ ${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
            : `€ ${amount}`;
        },
      },
    ];

    const columnsOrganisations = [
      {
        name: "name",
        label: "Name",
        field: "name",
        sortable: true,
        align: "left",
      },
    ];
    const scTimer = ref(0);
    const scY = ref(0);
    const handleScroll = () => {
      if (scTimer.value) return;
      scTimer.value = setTimeout(() => {
        scY.value = window.scrollY;
        clearTimeout(scTimer.value);
        scTimer.value = 0;
      }, 100);
    };

    const toTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    const scrollToIt = (el) => {
      const yOffset = -80;
      const element = document.getElementById(el);
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    };

    const download = async (documentId, documentName) => {
      await grantsService.downloadDocument(documentId).then((response) => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: response.data.type }),
        );
        var a = document.createElement("a");
        a.setAttribute("style", "display:none;");
        document.body.appendChild(a);
        a.download = documentName;
        a.href = fileURL;
        a.target = "_blank";
        a.click();
        document.body.removeChild(a);
      });
    };

    const getClickedOrganisation = (organisationId) => {
      localStorage.setItem("schemeOrganisation", organisationId);
      localStorage.setItem("schemeOrganisationClicked", true);
      localStorage.setItem("expandOrganisationItem", true);
    };

    const seeMoreNews = (title) => {
      store.commit("newsSearch/updateSearchText", title);

      router.push({
        name: "News",
      });
    };

    const toggleShowMore = () => (showMore.value = !showMore.value);

    const shareGrant = () => {
      store.commit("grantItems/enableShareGrant", scheme);
    };

    const enableSaveScheme = (id) => {
      store.commit("grantItems/addSelected", id);
      store.commit("user/enableSaveScheme");
    };

    const formattedMaxAmount = computed({
      get: () => store.state.grantItems.selectedGrantMax,
    });

    const formattedMinAmount = computed({
      get: () => store.state.grantItems.selectedGrantMin,
    });

    const newsInLastYear = computed({
      get: () => store.state.grantItems.newsInLastYear,
    });
    const olderNews = computed({
      get: () => store.state.grantItems.olderNews,
    });

    const areGrantDetailsLoading = computed({
      get: () => store.state.grantItems.areGrantDetailsLoading,
    });

    const downloadSchemePopup = (id) => {
      store.commit("grantItems/enableDownloadSchemeReport", id);
    };

    const formatDate = (stringDate) => {
      const dateN = new Date(stringDate);
      return moment(dateN).format("DD-MM-YYYY");
    };

    const openDetailsInNewTab = computed({
      get: () => store.state.user.openDetailsInNewTab,
    });

    const goToParent = () => {
      router.push({
        name: "GrantDetails",
        params: { grantId: scheme.value.parentSchemeId },
      });
    };
    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const isSKS = computed({
      get: () => store.state.auth.env === 30,
    });
    const hasUser = computed({
      get: () => store.state.auth.env !== 50 && store.state.auth.env !== 60,
    });
    const organisationsList = computed({
      get: () => store.state.grantItems.organisationsList,
    });

    const sortedLinksAndDocs = computed({
      get: () => store.state.grantItems.sortedLinksAndDocs,
    });

    const seeDeprecatedItems = ref(false);

    const updateSeeDeprecatedItems = (val) => {
      seeDeprecatedItems.value = val;
    };

    const isContrast = computed({
      get: () => store.state.user.isSelectedThemeContrast,
    });

    provide("isSKS", isSKS.value);
    provide("isVind", isVind.value);
    provide("hasUser", hasUser.value);

    const showMoreBudget = ref(false);

    const toggleShowMoreBudget = () => {
      showMoreBudget.value = !showMoreBudget.value;
    };

    window.addEventListener("scroll", navHighlighter);

    function navHighlighter() {
      let scrollY = window.pageYOffset;
      const sections = document.querySelectorAll("section[id]");
      sections.forEach((current) => {
        if (current != null && current) {
          const sectionHeight = current.offsetHeight;
          const sectionTop = current.offsetTop - 60;
          const sectionId = current.getAttribute("id");

          if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            document
              .querySelector(".navigation a[href*=" + sectionId + "]")
              .classList.add("active");
          } else {
            document
              .querySelector(".navigation a[href*=" + sectionId + "]")
              .classList.remove("active");
          }
        }
      });
    }
    const showSavedInfoDialog = computed({
      get: () => store.state.user.showSavedInfoDialog,
    });

    const disableShowSavedInfoDialog = () => {
      store.commit("user/disableShowSavedInfoDialog");
    };

    const receiveAlertForSavedItems = computed({
      get: () => store.state.user.receiveAlertForSavedItems,
      set: (val) => {
        store.commit("user/setReceiveAlertForSavedItems", val);

        UserService.updateFolderItemsAlert(
          savedSchemesFolderItemsIds.value,
          val,
        );
      },
    });

    const savedSchemesFolderItemsIds = computed({
      get: () => store.state.user.savedSchemesFolderItemsIds,
    });

    const getTranslation = async (schemeId) => {
      store.commit("grantItems/enableGrantDetailsLoading");
      await grantsService
        .translateScheme(schemeId, displayedCallsAndApplicationPeriodsIds.value, determineLocale())
        .then(() => store.commit("grantItems/disableGrantDetailsLoading"));
    };

    const transBody = computed({
      get: () => store.state.grantItems.selectedTransBody,
    });

    const transCriteria = computed({
      get: () => store.state.grantItems.selectedTransCriteria,
    });

    const transName = computed({
      get: () => store.state.grantItems.selectedTransName,
    });

    const transApplicationProcedure = computed({
      get: () => store.state.grantItems.selectedTransApplicationProcedure,
    });
    const transDuration = computed({
      get: () => store.state.grantItems.selectedTransDuration,
    });
    const transBudget = computed({
      get: () => store.state.grantItems.selectedTransBudget,
    });
    const transIntroduction = computed({
      get: () => store.state.grantItems.selectedTransIntroduction,
    });

    const transFinancialinformation = computed({
      get: () => store.state.grantItems.selectedTransFinancialinformation,
    });

    const transApplicationInformation = computed({
      get: () => store.state.grantItems.selectedTransApplicationInformation,
    });

    const determineLocale = () => {
      return scheme.value.isEnglishScheme && !translateScheme.value
        ? englishLocale
        : locale;
    };

    return {
      handleLoadedCallsAndApplicationPeriodsIds,
      authUser,
      determineLocale,
      transApplicationInformation,
      t,
      locale,
      transBody,
      transCriteria,
      transName,
      transApplicationProcedure,
      transIntroduction,
      transFinancialinformation,
      transDuration,
      transBudget,
      getTranslation,
      translateScheme,
      getClickedOrganisation,
      savedSchemesFolderItemsIds,
      receiveAlertForSavedItems,
      showSavedInfoDialog,
      disableShowSavedInfoDialog,
      showMoreBudget,
      toggleShowMoreBudget,
      isContrast,
      isUserFomo,
      schemeCustomersColumns,
      schemeCustomers,
      updateSeeDeprecatedItems,
      seeDeprecatedItems,
      sortedLinksAndDocs,
      organisationsList,
      isVind,
      isSKS,
      hasUser,
      goToParent,
      router,
      openDetailsInNewTab,
      formatDate,
      //downloadScheme,
      downloadSchemePopup,
      areGrantDetailsLoading,
      newsInLastYear,
      olderNews,
      formattedMaxAmount,
      formattedMinAmount,
      enableSaveScheme,
      shareGrant,
      seeMoreNews,
      download,
      scrollToIt,
      handleScroll,
      toTop,
      scTimer,
      scY,
      columns,
      route,
      scheme,
      shortIntro,
      showMore,
      toggleShowMore,
      columnsOrganisations,
      englishLocale,
      getSchemeById,
      EDocumentType,
      isDeprecatedDocumentType,
      displayedCallsAndApplicationPeriodsIds,
      iconBasedOnExtension(extension) {
        switch (extension) {
          case ".pdf":
            return "fa-solid fa-file-pdf";
          case ".doc":
            return "fa-solid fa-file-word";
          case ".docx":
            return "fa-solid fa-file-word";
          case ".xls":
            return "fa-solid fa-file-excel";
          case ".xlsx":
            return "fa-solid fa-file-excel";
          case ".csv":
            return "fa-solid fa-file-csv";
          case ".txt":
            return "fa-solid fa-file";
          default:
            return "fa-solid fa-file";
        }
      },
      getChanceOfSuccessRatingColor(rating) {
        switch (rating) {
          case 1:
            return "blue-10";
          case 2:
            return "blue-9";
          case 3:
            return "blue-7";
          case 4:
            return "blue-5";
          case 5:
            return "blue-3";
          default:
            return "blue-grey-2";
        }
      },
      getRatingColor(rating) {
        switch (rating) {
          case 1:
            return "blue-3";
          case 2:
            return "blue-5";
          case 3:
            return "blue-7";
          case 4:
            return "blue-9";
          case 5:
            return "blue-10";
          default:
            return "blue-grey-2";
        }
      },
      getTimeForApplicationRatingLabel(rating) {
        switch (rating) {
          case 5:
            return t("scheme_details.long_time");
          case 4:
            return t("scheme_details.slow");
          case 3:
            return t("scheme_details.average");
          case 2:
            return t("scheme_details.fast");
          case 1:
            return t("scheme_details.very_quick");
          default:
            return t("scheme_details.chance_of_success");
        }
      },
      getChanceOfSuccessRatingLabel(rating) {
        switch (rating) {
          case 1:
            return t("scheme_details.very_small");
          case 2:
            return t("scheme_details.small");
          case 3:
            return t("scheme_details.average");
          case 4:
            return t("scheme_details.big");
          case 5:
            return t("scheme_details.very_large");
          default:
            return t("scheme_details.chance_of_success");
        }
      },
      getComplexityRatingLabel(rating) {
        switch (rating) {
          case 5:
            return "Heel moeilijk";
          case 4:
            return "Moeilijk";
          case 3:
            return t("scheme_details.average");
          case 2:
            return "Eenvoudig";
          case 1:
            return "Heel eenvoudig";
          default:
            return t("scheme_details.difficulty");
        }
      },
    };
  },
};
</script>
]
